import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { AttendeeManagementRouteName } from '@client/feature/attendee-management/application/routes/attendee-management.route-name';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';
import { checkCurrentClientUserHasClient } from '@client/common/router/application/routes/check-current-client-user-has-client.route-guard';
import { checkClientHasSubscription } from '@client/common/router/application/routes/check-client-has-subscription.route-guard';

const AttendeeManagementAppModule = () => import('@client/feature/attendee-management/attendee-management.app-module');
const AttendeeManagementAttendeesListPage = () =>
  import('@client/feature/attendee-management/application/page/AttendeeManagementAttendeesListPage.vue');

export class AttendeeManagementModuleRoutes extends ModuleRoutes<AttendeeManagementRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'attendees/list',
        name: AttendeeManagementRouteName.AttendeesList,
        component: AttendeeManagementAttendeesListPage,
        beforeEnter: [
          loadLazyAppModuleGuard(AttendeeManagementAppModule, container),
          () => checkCurrentClientUserHasClient(),
          () => checkClientHasSubscription(),
        ],
      },
    ];

    super(routes);
  }
}
